import { nanoid } from 'nanoid';
import { safeJsonParse } from '@/utils/utils';

/**
 * 题目列表数据转换处理
 * 因为20250725之前复制的活动，会产生一些表单数据不全的内容
 * @param {Array} quesList 题目列表
 * @param {string} languageType 语言：zh：中文 en: 英文
 * @returns
 */
export function parseQuestions(quesList, languageType = 'zh') {
  for (const ques of quesList) {
    switch (ques.system_type) {
      // 性别
      case 4:
        if (!ques.items?.length) {
          ques.items = [
            {
              id: `qID_${nanoid()}`,
              ques_id: ques.id,
              subject: languageType === 'en' ? 'Female' : '女',
              type: 0,
              general_option_key: ''
            },
            {
              id: `qID_${nanoid()}`,
              ques_id: ques.id,
              subject: languageType === 'en' ? 'Male' : '男',
              type: 0,
              general_option_key: ''
            }
          ];
        }
        break;

      // 职位/职务/行业
      case 10:
      case 11:
      case 12:
        if (!ques.items?.length) {
          const options = safeJsonParse(ques.options);
          ques.items = (options?.general_field_options || []).map(subOpt => {
            return {
              id: `qID_${nanoid()}`,
              ques_id: ques.id,
              subject: subOpt[`option_names_${languageType}`]?.option_name,
              type: 0,
              general_option_key: subOpt.option_key
            };
          });
        }
        break;
      case 13:
        console.log('==========13====type=:', typeof ques.options)
        console.log('==========13=====:', ques.options, '')
        //   ques.options = "{}"
        break

      // 自定义
      case 0:
        // 单选题/多选题/下拉题
        if (ques.type == 2 || ques.type == 3 || ques.type == 4) {
          if (!ques.items?.length) {
            ques.items = [
              {
                id: `qID_${nanoid()}`,
                ques_id: ques.id,
                subject: languageType === 'en' ? 'Options' : '选项',
                type: 0,
                general_option_key: ''
              },
              {
                id: `qID_${nanoid()}`,
                ques_id: ques.id,
                subject: languageType === 'en' ? 'Options' : '选项',
                type: 0,
                general_option_key: ''
              }
            ];
          }
        }
    }
  }
  return quesList;
}
